class DotsObservers {
  observers;
  elementsClassName;
  dotsClassName;
  datasetName;
  activeClassName;
  activeRatio;

  constructor(
    elementsClassName = "",
    dotsClassName = "",
    datasetName = "",
    activeClassName = "",
    activeRatio = 55,
  ) {
    this.elementsClassName = elementsClassName;
    this.dotsClassName = dotsClassName;
    this.datasetName = datasetName;
    this.activeClassName = activeClassName;
    this.activeRatio = activeRatio;
    this.observers = [];
  }

  createObservers = () => {
    let observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: [0.45, 0.55],
    };

    const panels = document.querySelectorAll(this.elementsClassName);

    const _self = this;

    panels.forEach(() => {
      console.log(_self);
      const observer = new IntersectionObserver(
        _self.intersectionCallback,
        observerOptions,
      );

      this.observers.push(observer);
    });
  };

  intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      const panel = entry.target;

      const ratio = Math.floor(entry.intersectionRatio * 100);

      const _self = this;

      if (ratio >= 55) {
        document.querySelectorAll(_self.dotsClassName).forEach((dot, index) => {
          dot.classList.remove(_self.activeClassName);

          const panelData = parseInt(panel?.dataset[_self.datasetName]);

          if (index === panelData) {
            dot.classList.add(_self.activeClassName);
          }
        });
      }
    });
  };

  startObservers = () => {
    if (this.observers.length === 0) return;

    const panels = document.querySelectorAll(this.elementsClassName);

    const _self = this;

    panels.forEach((panel, index) => {
      _self.observers[index].observe(panel);
    });
  };

  stopObservers = () => {
    if (this.observers.length === 0) return;

    const panels = document.querySelectorAll(this.elementsClassName);

    const _self = this;

    panels.forEach((panel, index) => {
      _self.observers[index].unobserve(panel);
    });
  };

  destroyObservers = () => {
    if (this.observers.length === 0) return;

    this.observers = [];
  };
}

export default DotsObservers;
